.container
    height: 500px
    border-top: 1px solid #20212c
    margin-top: 30px
    padding-top: 10px
    p
        font-size: 20px
        font-weight: 500
